import axios from "axios";
import { auth } from "../firebase";

export const JURI_API_BASE = "https://jurident-api-596718606544.asia-south1.run.app"
 // process.env.REACT_APP_JURIDENT_API_URL || "http://localhost:8000";

const juriApi = axios.create({
  baseURL: JURI_API_BASE,
});

juriApi.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getAuthHeader = async () => {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

export default juriApi;
